module.exports = __webpack_public_path__ + "static/media/book3.48390652.jpg";